import { PaperProps, Box } from '@mui/material';
import React from 'react';

export const ModalPaper: React.FunctionComponent = function ({ sx, ...props }: PaperProps) {
    return (
        <Box
            {...props}
            sx={{
                ...sx,
                width: 600,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: '12px',
            }}
        />
    );
};
